import { forwardRef } from "react";

export const EmailIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(function EmailIcon(props, ref) {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Decorative icon
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>
      <path
        d="M3.51562 4.78125C3.26426 4.78125 3.05859 4.99219 3.05859 5.25V5.89746L7.98596 10.0459C8.57725 10.5439 9.42561 10.5439 10.0169 10.0459L14.9414 5.89746V5.25C14.9414 4.99219 14.7357 4.78125 14.4844 4.78125H3.51562ZM3.05859 7.7168V12.75C3.05859 13.0078 3.26426 13.2188 3.51562 13.2188H14.4844C14.7357 13.2188 14.9414 13.0078 14.9414 12.75V7.7168L10.8853 11.1328C9.78838 12.0557 8.20876 12.0557 7.11475 11.1328L3.05859 7.7168ZM1.6875 5.25C1.6875 4.21582 2.5073 3.375 3.51562 3.375H14.4844C15.4927 3.375 16.3125 4.21582 16.3125 5.25V12.75C16.3125 13.7842 15.4927 14.625 14.4844 14.625H3.51562C2.5073 14.625 1.6875 13.7842 1.6875 12.75V5.25Z"
        fill="currentColor"
      />
    </svg>
  );
});
